// Утилита для инъекции стилей dropdown меню
export function injectDropdownStyles() {
  // Проверяем, не добавлены ли уже стили
  if (document.getElementById('dropdown-styles')) {
    return;
  }

  const style = document.createElement('style');
  style.id = 'dropdown-styles';
  style.textContent = `
    .ant-dropdown-menu {
      max-height: 300px !important;
      overflow-y: auto !important;
      border-radius: 8px !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
      position: relative !important;
    }

    .ant-dropdown-menu::-webkit-scrollbar {
      width: 6px !important;
    }

    .ant-dropdown-menu::-webkit-scrollbar-track {
      background: #f5f5f5 !important;
      border-radius: 3px !important;
    }

    .ant-dropdown-menu::-webkit-scrollbar-thumb {
      background: #d9d9d9 !important;
      border-radius: 3px !important;
    }

    .ant-dropdown-menu::-webkit-scrollbar-thumb:hover {
      background: #bfbfbf !important;
    }

    .ant-dropdown-menu-item {
      padding: 8px 16px !important;
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      transition: all 0.2s ease !important;
    }

    .ant-dropdown-menu-item:hover {
      background: #e6f7ff !important;
    }

    .ant-dropdown-menu-item-disabled {
      color: #bfbfbf !important;
      cursor: not-allowed !important;
    }

    .ant-dropdown-menu-item-disabled:hover {
      background: transparent !important;
    }

    @media (max-width: 480px) {
      .ant-dropdown-menu {
        max-height: 250px !important;
      }
      
      .ant-dropdown-menu-item {
        padding: 6px 12px !important;
      }
    }
  `;

  document.head.appendChild(style);
}

// Функция для получения базовых стилей dropdown
export function getDropdownStyles(customStyles = {}) {
  const baseStyles = {
    position: 'absolute',
    zIndex: 1000,
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    maxHeight: '200px',
    overflowY: 'auto'
  };

  return { ...baseStyles, ...customStyles };
}

// Функция для расчета позиции dropdown
export function getDropdownPosition(element = null, window = null, dropdownHeight = 200) {
  // Если нет элемента или window, возвращаем позицию по умолчанию
  if (!element || !window) {
    return {
      top: '100%',
      left: '0'
    };
  }

  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const spaceBelow = windowHeight - rect.bottom;
  const spaceAbove = rect.top;

  // Если есть место снизу или места сверху меньше
  if (spaceBelow >= dropdownHeight || spaceBelow > spaceAbove) {
    return {
      top: '100%',
      left: '0'
    };
  } else {
    return {
      bottom: '100%',
      left: '0'
    };
  }
}

// Автоматически инжектируем стили при загрузке
if (typeof window !== 'undefined') {
  // Если DOM уже загружен
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectDropdownStyles);
  } else {
    injectDropdownStyles();
  }
} 